import React from 'react';

import { Alert, Button, Card, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { createProbeContent, getCadesError } from '@app/services/cades';
import { useComputerCheck } from '@app/services/hooks/useComputerCheck';
import { useProbeSignature } from '@app/services/hooks/useProbeSignature';
import { CadesChecks } from '@components/CadesChecks';
import { CertificateDetails } from '@components/CertificateDetails';
import { Paper } from '@components/Paper';

export const CryptoPro: React.FC = () => {
  const cadesT = useTranslation(NSKeys.cades);
  const commonT = useTranslation(NSKeys.common);
  const check = useComputerCheck();
  const probe = useProbeSignature();
  return (
    <Paper style={{ maxWidth: 960, margin: '32px auto', padding: 24 }}>
      <Flex vertical gap={16}>
        <Typography.Title level={2}>{cadesT.t('title')}</Typography.Title>
        <CadesChecks result={check.result} running={check.running} />
        <Button
          onClick={() => {
            probe.reset();
            check.recheck();
          }}
          disabled={probe.isLoading}
          loading={check.running}
        >
          {commonT.t('buttonReload')}
        </Button>
        {check.result?.certificates.map((certificate) => (
          <Card key={certificate.thumbprint} size="small">
            <Flex vertical gap={16}>
              <CertificateDetails certificate={certificate} />
              <Button
                disabled={check.running || !certificate.hasPrivateKey || probe.isLoading}
                onClick={() => probe.mutate({ certificate, content: createProbeContent(), count: 1 })}
              >
                {cadesT.t('checkKey')}
              </Button>
              {probe.variables?.certificate.thumbprint === certificate.thumbprint &&
                probe.data?.map((item, index) => (
                  <Alert
                    key={index}
                    type={item.error ? 'error' : 'success'}
                    showIcon
                    title={item.error ? cadesT.t('hints.license') : cadesT.t('signingWorks')}
                    description={item.error}
                  />
                ))}
            </Flex>
          </Card>
        ))}
        {probe.isError && (
          <Alert type="error" showIcon title={cadesT.t('hints.license')} description={getCadesError(probe.error)} />
        )}
      </Flex>
    </Paper>
  );
};
